<main class="container mx-auto p-6">
  <router-outlet />
  <core-sidebar [hasToggleButton]="false" />
</main>
